module.exports = __webpack_public_path__ + "static/media/gh-4.b6b2f3ae.png";